import { useState } from 'react';

import { ColumnConfigurationRenderAs } from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { DependencyDrawer } from '../../components/DependencyDrawer/DependencyDrawer';
import { ListTable } from '../../components/ListTable/ListTable';

type Props = {
  id: number;
};

const Button = ui.S9Button.default;
const { Space, useRefreshList } = ui;

const DependenciesDetail = ({ id }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();
  return (
    <ListTable
      queryVars={{
        requirementId: id,
      }}
      queryName="getdependenciesbyrequirement"
      title="Dependencies"
      columns={[
        {
          label: 'Requirement summary',
          field: 'requirement.summary',
          renderAs: ColumnConfigurationRenderAs.CustomComponent,
          options: {
            customComponentName: 'DependencyAction',
          },
          value: '{{sequence}}',
        },
        {
          label: 'Option set',
          field: 'option_set.option',
          renderAs: ColumnConfigurationRenderAs.Text,
          value: '{{option_set.option}}',
        },
      ]}
    >
      <div
        style={{ display: 'flex', justifyContent: 'end', marginBottom: '15px' }}
      >
        <DependencyDrawer
          initialValues={{ requirement_id: id }}
          open={isOpen}
          onClose={() => {
            setIsOpen(false);
            refresh();
          }}
        />
        <Space>
          <Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      </div>
    </ListTable>
  );
};

export default DependenciesDetail;
